import { useEffect } from "react";
import { isAllowed } from "../../api/access/decisions";
import { overviewDecision } from "../../api/projectsApi";
import { RELEASE_ACTION } from "../../features/knowledgeData";
import { appPaths } from "../../shared/routing/appPaths";
import { usePaneRedirect } from "../../shell/workspace";
import BlockedState from "../../ui/feedback/BlockedState";
import DangerZoneSection from "./danger/DangerZoneSection";
import ExportSection from "./export/ExportSection";
import PermissionHistoryPanel from "./history/PermissionHistoryPanel";
import { useProjectSettings } from "./projectSettingsContext";
import RulesSections from "./rules/RulesSections";
import ProjectNameField from "./ProjectNameField";

/** `/projects/<id>/settings` opens on Access. */
export function OpenAccessTab() {
  const { overview } = useProjectSettings();
  const redirect = usePaneRedirect();
  const to = appPaths.projectSettingsAccess(overview.project.projectId);
  useEffect(() => { redirect(to); }, [redirect, to]);
  return null;
}

/** Project › Rules: the project's rules and what the installation sets (ST-1). */
export function RulesTab() {
  const { overview, settings, settingsChanged } = useProjectSettings();
  return <RulesSections projectId={overview.project.projectId} settings={settings} changing={overviewDecision(overview, "manage_project_settings")} onChanged={settingsChanged} />;
}

/** Project › History: which permissions existed when (Q-67), for those who manage people. */
export function HistoryTab() {
  const { overview } = useProjectSettings();
  return <PermissionHistoryPanel projectId={overview.project.projectId} />;
}

/** Project › General: its export (F11) and, last, the danger zone for deleting it (F121). */
export function GeneralTab() {
  const { overview, settings, permissionsChanged } = useProjectSettings();
  const { project } = overview;
  return (
    <div className="max-w-4xl space-y-8">
      <BlockedState decision={overviewDecision(overview, "delete_project")}>
        <ProjectNameField key={project.name} projectId={project.projectId} projectName={project.name} onChanged={permissionsChanged} />
      </BlockedState>
      <ExportSection
        projectId={project.projectId}
        releasing={overviewDecision(overview, RELEASE_ACTION)}
        downloading={overviewDecision(overview, "read_repository")}
      />
      {isAllowed(overviewDecision(overview, "delete_project")) ? (
        <DangerZoneSection projectId={project.projectId} projectName={project.name} restoreDays={settings.installation.deletedProjectRestoreDays} />
      ) : null}
    </div>
  );
}
